export const ConstantsHindi = {
    patterns: [
        {
            "search_word":"ड़",
            "replace_word" : "ड़"
        },
        {
            "search_word":"ढ़",
            "replace_word":"ढ़"
        },
        {
            "search_word":"ड़ा",
            "replace_word":"ड़ा"
        },
        {
            "search_word":"ड़ि",
            "replace_word":"ड़ि"
        },
        {
            "search_word":"ड़ो",
            "replace_word":"ड़ो"
        },
        {
            "search_word":"ढ़",
            "replace_word":"ढ़"
        },
        {
            "search_word":"ढ़ा",
            "replace_word":"ढ़ा"
        },
    ],
	//replacement while copying
    fix_patterns: [
        {
            "search_word":"য়",
            "replace_word":"য়"
        },
        {
            "search_word":"ড়",
            "replace_word":"ড়"
        },
        {
            "search_word":"ঢ়",
            "replace_word":"ঢ়"
        },
        {
            "search_word":"য়া",
            "replace_word":"য়া"
        },
        {
            "search_word":"ড়ো",
            "replace_word":"ড়ো"
        },
        {
            "search_word":"ঢ়ো",
            "replace_word":"ঢ়ো"
        },
        {
            "search_word":"ঢ়োঁ",
            "replace_word":"ঢ়োঁ"
        },
    ],
    variations:
    {
        // বিকল্প আখৰ আৰু শব্দৰ তালিকা।
        //"বিকল্পটো":"মূলটো" (মূলটো আছে, বিকল্পে ইটোও শুদ্ধ -এই কনচেপ্ট।// থকাটো যিকোনো এফালে //দিব লাগিব)
        "र्च": "र्च्च",
		"र्ण": "र्ण्ण",
		"र्त": "र्त्त",
        "र्द": "र्द्द",
        "र्म": "र्म्म",
		"क": ["क़", "क़"],
		"ख": ["ख", "ख़", "ख़"],
		"ग": ["ग़", "ग़"],
		"ज": ["ज़", "ज़"],
		"ड़": ["ड़"],
		"ढ़": ["ढ़"],
		"झ": "झ़",
		"फ": ["फ़", "फ़"],
		"इज्जत": "इज़्ज़त",
		"धुआँ": "धुआं",
		"धुँधुवा": "धुंधुवा",
		"सुरखरू": ["सुर्ख़रू", "सुर्खरू"],
		"अंक": ["अङ्क"],
	"अङ्ग": ["अंग", "अंगीय"],
	
    },
    suggestion_replacement: {
        "ञ्क": "ंक",
		"न्क": ["ंक", "क"],
		"ऊं": "ऊँ",
		"ड़": "ड",
		"ड़": "ड",
		"ढ़": "ढ",
		"ढ़": "ढ",
		"ঃ": ":",
		"ु": "ू",
		"ू": "ु",
		"ि": "ी",
		"ी": "ि",
		"कूं": "कूँ",
		"खूं": "खूँ",
		"गूं": "गूँ",
		"घूं": "घूँ",
		"चूं": "चूँ",
		"छूं": "छूँ",
		"जूं": "जूँ",
		"झूं": "झूँ",
		"टूं": "टूँ",
		"ठूं": "ठूँ",
		"डूं": "डूँ",
		"ढूं": "ढूँ",
		"तूं": "तूँ",
		"थूं": "थूँ",
		"दूं": "दूँ",
		"धूं": "धूँ",
		"पूं": "पूँ",
		"फूं": "फूँ",
		"बूं": "बूँ",
		"भूं": "भूँ",
		"यूं": "यूँ",
		"रूं": "रूँ",
		"लूं": "लूँ",
		"वूं": "वूँ",
		"शूं": "शूँ",
		"षूं": "षूँ",
		"सूं": "सूँ",
		"हूं": "हूँ",	
		"कुँ": "कूँ",
		"खुँ": "खूँ",
		"गुँ": "गूँ",
		"घुँ": "घूँ",
		"चुँ": "चूँ",
		"छुँ": "छूँ",
		"जुँ": "जूँ",
		"झुँ": "झूँ",
		"टुँ": "टूँ",
		"ठुँ": "ठूँ",
		"डुँ": "डूँ",
		"ढुँ": "ढूँ",
		"तुँ": "तूँ",
		"थुँ": "थूँ",
		"दुँ": "दूँ",
		"धुँ": "धूँ",
		"पुँ": "पूँ",
		"फुँ": "फूँ",
		"बुँ": "बूँ",
		"भुँ": "भूँ",
		"युँ": "यूँ",
		"रुँ": "रूँ",
		"लुँ": "लूँ",
		"वुँ": "वूँ",
		"शुँ": "शूँ",
		"षुँ": "षूँ",
		"सुँ": "सूँ",
		"हुँ": "हूँ",
		"कूँ": "कुँ",
		"खूँ": "खुँ",
		"गूँ": "गुँ",
		"घूँ": "घुँ",
		"चूँ": "चुँ",
		"छूँ": "छुँ",
		"जूँ": "जुँ",
		"झूँ": "झुँ",
		"टूँ": "टुँ",
		"ठूँ": "ठुँ",
		"डूँ": "डुँ",
		"ढूँ": "ढुँ",
		"तूँ": "तुँ",
		"थूँ": "थुँ",
		"दूँ": "दुँ",
		"धूँ": "धुँ",
		"पूँ": "पुँ",
		"फूँ": "फुँ",
		"बूँ": "बुँ",
		"भूँ": "भुँ",
		"यूँ": "युँ",
		"रूँ": "रुँ",
		"लूँ": "लुँ",
		"वूँ": "वुँ",
		"शूँ": "शुँ",
		"षूँ": "षुँ",
		"सूँ": "सुँ",
		"हूँ": "हुँ",
		"कू": "कु",
		"खू": "खु",
		"गू": "गु",
		"घू": "घु",
		"चू": "चु",
		"छू": "छु",
		"जू": "जु",
		"झू": "झु",
		"टू": "टु",
		"ठू": "ठु",
		"डू": "डु",
		"ढू": "ढु",
		"णू": "णु",
		"तू": "तु",
		"थू": "थु",
		"दू": "दु",
		"धू": "धु",
		"नू": "नु",
		"पू": "पु",
		"फू": "फु",
		"बू": "बु",
		"भू": "भु",
		"मू": "मु",
		"यू": "यु",
		"रू": "रु",
		"लू": "लु",
		"वू": "वु",
		"शू": "शु",
		"षू": "षु",
		"सू": "सु",
		"हू": "हु",
		"क्षू": "क्षु",
		"कु": "कू",
		"खु": "खू",
		"गु": "गू",
		"घु": "घू",
		"चु": "चू",
		"छु": "छू",
		"जु": "जू",
		"झु": "झू",
		"टु": "टू",
		"ठु": "ठू",
		"डु": "डू",
		"ढु": "ढू",
		"णु": "णू",
		"तु": "तू",
		"थु": "थू",
		"दु": "दू",
		"धु": "धू",
		"नु": "नू",
		"पु": "पू",
		"फु": "फू",
		"बु": "बू",
		"भु": "भू",
		"मु": "मू",
		"यु": "यू",
		"रु": "रू",
		"लु": "लू",
		"वु": "वू",
		"शु": "शू",
		"षु": "षू",
		"सु": "सू",
		"हु": "हू",
		"क्षु": "क्षू",
		"कि": "की",
		"खि": "खी",
		"गि": "गी",
		"घि": "घी",
		"चि": "ची",
		"छि": "छी",
		"जि": "जी",
		"झि": "झी",
		"टि": "टी",
		"ठि": "ठी",
		"डि": "डी",
		"ढि": "ढी",
		"णि": "णी",
		"ति": "ती",
		"थि": "थी",
		"दि": "दी",
		"धि": "धी",
		"नि": "नी",
		"पि": "पी",
		"फि": "फी",
		"बि": "बी",
		"भि": "भी",
		"मि": "मी",
		"यि": "यी",
		"रि": "री",
		"लि": "ली",
		"वि": "वी",
		"शि": "शी",
		"षि": "षी",
		"सि": "सी",
		"हि": "ही",
		"क्षि": "क्षी",
		"की": "कि",
		"खी": "खि",
		"गी": "गि",
		"घी": "घि",
		"ची": "चि",
		"छी": "छि",
		"जी": "जि",
		"झी": "झि",
		"टी": "टि",
		"ठी": "ठि",
		"डी": "डि",
		"ढी": "ढि",
		"णी": "णि",
		"ती": "ति",
		"थी": "थि",
		"दी": "दि",
		"धी": "धि",
		"नी": "नि",
		"पी": "पि",
		"फी": "फि",
		"बी": "बि",
		"भी": "भि",
		"मी": "मि",
		"री": "रि",
		"ली": "लि",
		"वी": "वि",
		"शी": "शि",
		"षी": "षि",
		"सी": "सि",
		"ही": "हि",
		"क्षी": "क्षि",
		"के": "कै",
		"खे": "खै",
		"गे": "गै",
		"घे": "घै",
		"चे": "चै",
		"छे": "छै",
		"जे": "जै",
		"झे": "झै",
		"टे": "टै",
		"ठे": "ठै",
		"डे": "डै",
		"ढे": "ढै",
		"णे": "णै",
		"ते": "तै",
		"थे": "थै",
		"दे": "दै",
		"धे": "धै",
		"ने": "नै",
		"पे": "पै",
		"फे": "फै",
		"बे": "बै",
		"भे": "भै",
		"मे": "मै",
		"रे": "रै",
		"ले": "लै",
		"वे": "वै",
		"शे": "शै",
		"षे": "षै",
		"से": "सै",
		"हे": "है",
		"क्षे": "क्षै",
		"कै": "के",
		"खै": "खे",
		"गै": "गे",
		"घै": "घे",
		"चै": "चे",
		"छै": "छे",
		"जै": "जे",
		"झै": "झे",
		"टै": "टे",
		"ठै": "ठे",
		"डै": "डे",
		"ढै": "ढे",
		"णै": "णे",
		"तै": "ते",
		"थै": "थे",
		"दै": "दे",
		"धै": "धे",
		"नै": "ने",
		"पै": "पे",
		"फै": "फे",
		"बै": "बे",
		"भै": "भे",
		"मै": "मे",
		"यै": "ये",
		"रै": "रे",
		"लै": "ले",
		"वै": "वे",
		"शै": "शे",
		"षै": "षे",
		"सै": "से",
		"है": "हे",
		"क्षै": "क्षे",
		"उँ": "ऊँ",
		"यी": "ई",
		"ये": "ए",
		"यें": "एँ",
		"एं": "एँ",
		"सङ्गीत": "संगीत",
		"चञ्चल": "चंचल",
		"बम्पर": "बंपर",
		"ङ्ग" : "ंग",
		"सञ्चार": "संचार",
		"सञ्जीवनी": "संजीवनी",
		"डङ्का": "डंका",
		"मन्त्र": "मंत्र",
		"वन्दन": "वंदन",
		"संभल": "सँभल",
		"पण्डित": "पंडित",
		"ताण्डव": "तांडव",
		"सम्भव": "संभव",
		"गङ्गा": "गंगा",
		"बन्द": "बंद",
		"सङ्कल्प": "संकल्प",
		"सम्पत्ति": "संपत्ति",
		"डन्डा": "डण्डा",
		"डञ्डा": "डण्डा",
		"सम्वाद": "संवाद",
		"मृन्मय": "मृण्मय",
		"मुमूर्षु": "मुमुर्षु",
		"अत्याधिक": "अत्यधिक",
		"बिआना": "बुआना",
		"करकर": "करके",
		"भरक": "भड़क",
		"मूंड़": "मूड़",
		"मूंड़": "मूड़",
		"भीज": "भींज",
		"करा": "किया",
		"करे": "किए",
		"लेया": "लिया",
		"देया": "दिया",
		"शहा": "सहा",
		"सिकोड़": "सिकुड़",
		"सिकोड़": "सिकुड़",
		"दिएँ": "दें",
		"हारा": "हरा",
		"हो": "हु",
		"हाँड़": "हाँड",
		"हाँड़": "हाँड",
		"हँड": "हाँड",
		"नयता": "न्यता",
		"गयता": "ग्यता",
		}
}
